import { enquiryList } from "../../../api/Enquiry";
import { formatToDate } from "../../master/FormatToDateTime";
import { SweetAlertShow } from "../../master/Master";
import DownloadExcel from "../../master/DownloadExcel";
import { PrintPage } from "../../master/Print";
import { followupsList } from "../../../api/FollowUps";

export const handleEnquiryDownload = async (
  type = "excel",
  setLoading,
  filters = {}
) => {
  setLoading(true);

  try {
    const downloadData = [];
    let firstUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== undefined && value !== null && value !== "") {
        if (key !== "page") {
          firstUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      }
    });

    const firstResponse = await enquiryList(`page=1${firstUrl}`);
    if (!firstResponse?.data?.status) {
      SweetAlertShow("info", "Warning", firstResponse?.data?.message);
      return;
    }

    const lastPage = firstResponse?.data?.data?.last_page || 1;

    const mapRows = (items) =>
      items.map((item) => ({
        "Student Name": item?.student_name ?? "",
        "Father Name": item?.father_name ?? "",
        Mobile: item?.mobile ?? "",
        Email: item?.email ?? "",
        Address: `${item?.village ?? ""} ${item?.district ?? ""} ${
          item?.state ?? ""
        } ${item?.pincode ?? ""}`,
        Category: item?.category ?? "",
        Gender: item?.gender ?? "",
        "Enquiry Date": formatToDate(item?.enquiry_date) ?? "",
        Source: item?.source ?? "",
        Course: item?.course?.title ?? "",
        "Reference Detail": item?.reference_detail ?? "",
        Note: item?.note ?? "",
        "Creator By": item?.creator_by?.name || "",
        Status:
          item.status === "1"
            ? "Admitted"
            : item.status === "0"
            ? "Pending"
            : item.status === "4"
            ? "Demo"
            : item.status === "2"
            ? "Not Interested"
            : item.status === "5"
            ? "Visits"
            : "Pending" ?? "",
        "Last Followup Date": formatToDate(item?.followup_date) ?? "",
        "Next Followup Date": formatToDate(item?.next_followup_date) ?? "",
        "Manual_Remark ": "",
      }));

    downloadData.push(...mapRows(firstResponse?.data?.data?.data || []));

    for (let page = 2; page <= lastPage; page++) {
      const response = await enquiryList(`page=${page}${firstUrl}`);

      if (response?.data?.status) {
        downloadData.push(...mapRows(response?.data?.data?.data || []));
      }
    }

    if (downloadData.length) {
      if (type === "excel") {
        const now = new Date();

        const fileName = `Report_${now.getFullYear()}_${
          now.getMonth() + 1
        }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

        DownloadExcel(downloadData, [], fileName, []);
      } else {
        PrintPage(downloadData);
      }
    } else {
      SweetAlertShow("info", "Info", "No records found");
    }
  } catch (err) {
    SweetAlertShow(
      "error",
      "Error",
      err?.response?.data?.message || err?.message
    );
  } finally {
    setLoading(false);
  }
};

export const getEnquiries = async ({ setLoading, filters, setData }) => {
  setLoading(true);
  let addUrl = "";
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      addUrl += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  try {
    const response = await enquiryList(addUrl);
    if (response.data.status) {
      setData(response?.data?.data);
    } else {
      SweetAlertShow("info", "Warning", response?.data?.message);
    }
  } catch (error) {
    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ?? error?.response?.message
    );
  } finally {
    setLoading(false);
  }
};

export const EnquiryStatusBadge = (status) => {
  switch (Number(status)) {
    case 1:
      return (
        <button className="btn btn-sm btn-outline-success px-2 py-1">
          Admitted
        </button>
      );
    case 0:
      return (
        <button
          className="btn btn-sm btn-outline-warning px-2 py-1"
          data-bs-toggle="modal"
          data-bs-target="#StatusChange"
        >
          Pending
        </button>
      );
    case 2:
      return (
        <button
          className="btn btn-sm btn-outline-secondary px-2 py-1"
          data-bs-toggle="modal"
          data-bs-target="#StatusChange"
        >
          Not Interested
        </button>
      );
    case 4:
      return (
        <button
          className="btn btn-sm btn-outline-info px-2 py-1"
          data-bs-toggle="modal"
          data-bs-target="#StatusChange"
        >
          Demo
        </button>
      );

    case 5:
      return (
        <button
          className="btn btn-sm btn-outline-primary px-2 py-1"
          data-bs-toggle="modal"
          data-bs-target="#StatusChange"
        >
          Visits
        </button>
      );
    default:
      return (
        <button
          className="btn btn-sm btn-outline-warning px-2 py-1"
          data-bs-toggle="modal"
          data-bs-target="#StatusChange"
        >
          New
        </button>
      );
  }
};

export const getFollowupsList = async ({ setLoading, filters, setData }) => {
  setLoading(true);
  let addUrl = "type=enquiry";
  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value) {
      addUrl += `&${key}=${encodeURIComponent(value)}`;
    }
  });
  try {
    const response = await followupsList(addUrl);
    if (response.data.status) {
      setData(response?.data?.data);
    } else {
      SweetAlertShow("info", "Warning", response?.data?.message);
    }
  } catch (error) {
    SweetAlertShow(
      "error",
      "Error",
      error?.response?.data?.message ?? error?.response?.message
    );
  } finally {
    setLoading(false);
  }
};

export const handleFollowupsDownload = async (
  type = "excel",
  setLoading,
  filters = {}
) => {
  setLoading(true);

  try {
    const downloadData = [];
    let firstUrl = "type=enquiry";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== undefined && value !== null && value !== "") {
        if (key !== "page") {
          firstUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      }
    });

    const firstResponse = await followupsList(`page=1${firstUrl}`);
    if (!firstResponse?.data?.status) {
      SweetAlertShow("info", "Warning", firstResponse?.data?.message);
      return;
    }

    const lastPage = firstResponse?.data?.data?.last_page || 1;

    const mapRows = (items) =>
      items.map((item) => ({
        "Student Name": item?.enquiry?.student_name ?? "",
        "Father Name": item?.enquiry?.father_name ?? "",
        Mobile: item?.enquiry?.mobile ?? "",
        Email: item?.enquiry?.email ?? "",
        Address: `${item?.enquiry?.village ?? ""} ${
          item?.enquiry?.district ?? ""
        } ${item?.enquiry?.state ?? ""} ${item?.enquiry?.pincode ?? ""}`,
        Course: item?.enquiry?.course?.title ?? "",
        "Reference Detail": item?.enquiry?.reference_detail ?? "",
        Note: item?.enquiry?.note ?? "",
        "Creator By": item?.enquiry?.creator_by?.name || "",
        Status:
          item.enquiry?.status === "1"
            ? "Admitted"
            : item?.enquiry?.status === "0"
            ? "Pending"
            : item?.enquiry?.status === "4"
            ? "Demo"
            : item?.enquiry?.status === "2"
            ? "Not Interested"
            : item?.enquiry?.status === "5"
            ? "Visits"
            : "Pending" ?? "",
        "Last Followup Date": formatToDate(item?.followup_date) ?? "",
        "Last Response": item?.response ?? "",
        "Next Followup Date": formatToDate(item?.next_followup_date) ?? "",
        "Manual_Remark ": "",
      }));

    downloadData.push(...mapRows(firstResponse?.data?.data?.data || []));

    for (let page = 2; page <= lastPage; page++) {
      const response = await followupsList(`page=${page}${firstUrl}`);

      if (response?.data?.status) {
        downloadData.push(...mapRows(response?.data?.data?.data || []));
      }
    }

    if (downloadData.length) {
      if (type === "excel") {
        const now = new Date();

        const fileName = `Report_${now.getFullYear()}_${
          now.getMonth() + 1
        }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

        DownloadExcel(downloadData, [], fileName, []);
      } else {
        PrintPage(downloadData);
      }
    } else {
      SweetAlertShow("info", "Info", "No records found");
    }
  } catch (err) {
    SweetAlertShow(
      "error",
      "Error",
      err?.response?.data?.message || err?.message
    );
  } finally {
    setLoading(false);
  }
};
